import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "./api";
import { handleResponseStatus } from "./utils";
import { FinancialSource } from "../enums/enums";

const initialMenuState = {
    items: [
        {
            name: "Dashboard",
            url: "/",
            iconClass: "",
            status: true,
            permissions: ['SuperAdmin', 'RestaurantAdmin', 'RestaurantOwner', 'BranchAdmin', 'BranchOwner', 'BranchManager', 'BranchEmployee'],
        },
        {
            name: "Orders",
            url: "/order",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager', 'BranchEmployee'],
        },
        {
            name: "Tags",
            url: "/tag",
            iconClass: "",
            status: true,
            permissions: ['RestaurantAdmin', 'RestaurantOwner', 'BranchAdmin', 'BranchOwner'],
        },
        {
            name: "Products",
            url: "product",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
            children: [
                {
                    name: "All Products",
                    url: "product/",
                    iconClass: "",
                    status: true,
                    permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                },
                {
                    name: "Manage Products",
                    url: "product/manage",
                    iconClass: "",
                    status: true,
                    permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                },
                {
                    name: "Recommended Products",
                    url: "product/recommended",
                    iconClass: "",
                    status: true,
                    permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                },
                {
                    name: "Stock Alert",
                    url: "product/alert",
                    iconClass: "",
                    status: true,
                    permissions: ['BranchAdmin', 'BranchOwner'],
                },
            ]
        },
        {
            name: "Restaurants",
            url: "/restaurant",
            iconClass: "",
            status: true,
            permissions: ['SuperAdmin'],
        },
        {
            name: "Subscription",
            url: "/subscription",
            iconClass: "",
            status: true,
            permissions: ['SuperAdmin'],
        },
        {
            name: "Branches",
            url: "/branch",
            iconClass: "",
            status: true,
            permissions: ['SuperAdmin'],
        },
        {
            name: "Users",
            url: "/user",
            iconClass: "",
            status: true,
            permissions: ['SuperAdmin'],
        },
        {
            name: "Employees",
            url: "/employee",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner'],
        },
        {
            name: "Customers",
            url: "/customer",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner'],
        },
        {
            name: "Discount",
            url: "/discount",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner'],
        },
        {
            name: "Vendor",
            url: "/vendor",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner'],
        },
        {
            name: "Purchase Order",
            url: "/purchase",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
        },
        {
            name: "Orders Internal",
            url: "/internalOrder",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
        },
        {
            name: "Reports",
            url: "report/topselling",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner'],
            children: [
                {
                    name: "Top Selling Products",
                    url: "report/topselling",
                    iconClass: "",
                    status: true,
                    permissions: ['BranchAdmin', 'BranchOwner'],
                },
                {
                    name: "Financial Report",
                    url: "report/financialReport",
                    iconClass: "",
                    status: true,
                    permissions: ['BranchAdmin', 'BranchOwner'],
                },
            ]
        },
        {
            name: "Transaction Type",
            url: "/transactionType",
            iconClass: "",
            status: true,
            permissions: ['RestaurantAdmin', 'RestaurantOwner'],
        },
        {
            name: "Transactions",
            url: "/transactions",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner'],
        },
        {
            name: "Recurring Expense",
            url: "/recurring",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner'],
        },
        {
            name: "Track Order",
            url: "/trackOrder",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager', 'BranchEmployee'],
        },
        {
            name: "Invoice",
            url: "/invoice",
            iconClass: "",
            status: true,
            permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
            children: [
                {
                    name: "All Invoices",
                    url: "invoice",
                    iconClass: "",
                    status: true,
                    permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                },
                {
                    name: "Bank",
                    url: "invoice/bank",
                    iconClass: "",
                    status: true,
                    permissions: ['BranchAdmin', 'BranchOwner'],
                },
                {
                    name: "Create Invoice",
                    url: "invoice/create",
                    iconClass: "",
                    status: true,
                    permissions: ['BranchAdmin', 'BranchOwner', 'BranchManager'],
                },
            ]
        },
    ],
    transactionType: {
        items: [],
        status: "idle",
        error: null,
    },
}

// Fetch Transaction Type
export const fetchTransactionType = createAsyncThunk("menu/fetchTransactionType", async ({ roleSign }) => {
    try {
        const response = await api.get(`/${roleSign}/transactionType`);
        return { ...response };
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
}
);
const updateItem = (data, state, FinancialSource) => {
    // Filter out any previously added FinancialSource menus
    const filteredItems = state.items.filter(
        item => item.id !== FinancialSource.Income && item.id !== FinancialSource.Expense
    );

    const menus = [
        {
            id: FinancialSource.Income,
            name: FinancialSource.Income + " Products",
            url: "/income",
            iconClass: "",
            status: true,
            permissions: ['RestaurantAdmin', 'RestaurantOwner'],
            children: []
        },
        {
            id: FinancialSource.Expense,
            name: FinancialSource.Expense + " Products",
            url: "/expense",
            iconClass: "",
            status: true,
            permissions: ['RestaurantAdmin', 'RestaurantOwner'],
            children: []
        },
        // {
        //     name: "Building",
        //     url: "/building",
        //     iconClass: "",
        //     status: true,
        //     permissions: ['RestaurantAdmin', 'RestaurantOwner'],
        // },
        {
            name: "Contact us",
            url: "/contact",
            iconClass: "",
            status: true,
            permissions: ['RestaurantAdmin', 'RestaurantOwner'],
        },
    ];

    data.forEach(item => {
        const source = item.source === "Both" ? FinancialSource.Income : item.source;
        const parentMenu = menus.find(menu => menu.id === source);
        if (parentMenu) {
            parentMenu.children.push({
                name: item.name,
                url: `${parentMenu.url}/${item.name.toLowerCase().replace(/\s+/g, '')}`,
                iconClass: "",
                status: item.status === 1,
                permissions: parentMenu.permissions, // inherit permissions
            });
        }
    });

    return [...filteredItems, ...menus];
};


const menuSlice = createSlice({
    name: "menu",
    initialState: initialMenuState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchTransactionType.fulfilled, (state, action) => {
                const { fetchStatus, error } = handleResponseStatus(action.payload, "fetchStatus");
                state.transactionType.items = fetchStatus === "success" ? action.payload.data.data : state.transactionType.items;
                state.items = fetchStatus === "success" ? updateItem(action.payload.data.data, state, FinancialSource) : state.items;
                state.transactionType.status = fetchStatus;
                state.transactionType.error = error;
            });
    },
});

// Selector to filter menu based on user role

export const selectMenuByRole = (menu, userRole) => {
    const filterMenu = (items) =>
        items
            .filter(item => item.permissions.includes(userRole))
            .map(item => ({
                ...item,
                children: item.children ? filterMenu(item.children) : undefined
            }));

    return filterMenu(menu);
};

export default menuSlice.reducer;
